export default __webpack_public_path__ + "static/media/vitalsmd-portal-square-logo.9133c9a3.svg";